export enum AccountRelationMetadataType {
  EntityOwnerName = 1,
  EntityOwnerEmail =  2,
  EntityName = 3,
  EntityPhone = 4,
  EntityAddress = 5,

  Entity = 6,
  EntityOwner = 7,
  EntityMembers = 8,
}
